export const HIGH_DETRACTOR_SEGMENT_ID = 3
